export const DEFAULT_BREAK_DURATION_MINUTES = 5;
export const MIN_BREAK_DURATION_MINUTES = 1;
export const MAX_BREAK_DURATION_MINUTES = 60;

export const DEFAULT_POMODORO_SCORE = 10;
export const MIN_POMODORO_SCORE = 1;
export const MAX_POMODORO_SCORE = 100;
export const DEFAULT_REVIEWED_NOTE_SCORE = 10;
export const DEFAULT_REVIEWED_CARD_SCORE = 10;
export const MIN_PRODUCTIVITY_SCORE = 1;
export const MAX_PRODUCTIVITY_SCORE = 100;

export function clampProductivityScore(value, defaultValue) {
    const nextValue = Number(value);
    if (!Number.isFinite(nextValue)) return defaultValue;
    return Math.min(MAX_PRODUCTIVITY_SCORE, Math.max(MIN_PRODUCTIVITY_SCORE, Math.trunc(nextValue)));
}

export function clampBreakDurationMinutes(value) {
    const nextValue = Number(value);

    if (!Number.isFinite(nextValue)) {
        return DEFAULT_BREAK_DURATION_MINUTES;
    }

    return Math.min(
        MAX_BREAK_DURATION_MINUTES,
        Math.max(MIN_BREAK_DURATION_MINUTES, Math.trunc(nextValue))
    );
}

export function readBreakDurationMinutes(settings) {
    return clampBreakDurationMinutes(
        settings?.break_duration ?? settings?.breakDuration ?? DEFAULT_BREAK_DURATION_MINUTES
    );
}
